import { render, staticRenderFns } from "./storeroom._stock.vue?vue&type=template&id=63d2e1ff&"
import script from "./storeroom._stock.vue?vue&type=script&lang=js&"
export * from "./storeroom._stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports